import { theme } from './theme';

export const styles = {
  // Card styles
  card: {
    background: theme.colors.card,
    borderRadius: theme.borderRadius.xl,
    padding: theme.spacing['2xl'],
    boxShadow: theme.shadows.card,
  },

  // Input styles
  input: {
    padding: `${theme.spacing.lg} ${theme.spacing.lg}`,
    border: `2px solid ${theme.colors.border}`,
    borderRadius: theme.borderRadius.md,
    fontSize: theme.fontSize.md,
    transition: `border-color ${theme.transitions.fast}`,
  },

  inputFocus: {
    borderColor: theme.colors.teal,
  },

  // Button styles
  button: {
    padding: `${theme.spacing.lg} ${theme.spacing['2xl']}`,
    borderRadius: theme.borderRadius.lg,
    fontSize: theme.fontSize.lg,
    fontWeight: theme.fontWeight.semibold,
    border: 'none',
    transition: `all ${theme.transitions.fast}`,
  },

  buttonPrimary: {
    background: theme.gradients.primary,
    color: theme.colors.card,
  },

  // Tag/chip styles
  tag: {
    padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
    background: theme.colors.paper,
    border: `2px solid ${theme.colors.border}`,
    borderRadius: theme.borderRadius.full,
    fontSize: theme.fontSize.base,
    cursor: 'pointer',
    transition: `all ${theme.transitions.fast}`,
  },

  tagActive: {
    background: theme.colors.teal,
    borderColor: theme.colors.teal,
    color: theme.colors.card,
  },

  // Section title
  sectionTitle: {
    fontSize: theme.fontSize.xl,
    fontWeight: theme.fontWeight.semibold,
    marginBottom: theme.spacing.lg,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.sm,
  },
};

// Helper to merge styles
export const mergeStyles = (...styleObjects: React.CSSProperties[]): React.CSSProperties => {
  return Object.assign({}, ...styleObjects);
};
